import type { ConversationNodePhoneNumber } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodePhoneNumber;
};

export function RoutedThroughLocation({ node }: Props): JSX.Element {
  return (
    <>
      Location ·{' '}
      {node.match === true ? <strong>{node.name}</strong> : 'No match'}
    </>
  );
}
